module.exports = __webpack_public_path__ + "src/assets/img/btn.a866fcf6.png";